import { callAPI } from "./api";

function getAssociationUserData(){
    return callAPI("/Associations", {method: "GET"});
}

export {
    getAssociationUserData
}